import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { blogPosts } from '@/data/blogPosts.index';
import { loadBlogPost } from '@/data/blog-mdx/loader';
import { isVisible } from '@/lib/draftPreview';
import BlogPost from './BlogPost';

const BlogPostPage = () => {
  const { slug } = useParams();
  const metadata = blogPosts.find((post) => post.slug === slug && isVisible(post));
  const [state, setState] = useState({ slug: null, post: null, failed: false });

  useEffect(() => {
    let active = true;
    if (!metadata) return () => { active = false; };

    loadBlogPost(metadata)
      .then((post) => {
        if (active) setState({ slug, post, failed: false });
      })
      .catch((error) => {
        console.error('[blog] failed to load post body', error);
        if (active) setState({ slug, post: null, failed: true });
      });
    return () => { active = false; };
  }, [metadata, slug]);

  if (!metadata || (state.slug === slug && state.failed)) return <Navigate to="/blog" replace />;
  if (state.slug !== slug || !state.post) {
    return <div className="min-h-screen pt-32 text-center text-gray-600">Loading article…</div>;
  }
  return <BlogPost post={state.post} />;
};

export default BlogPostPage;
